import {WhiteButton} from '@/components/Button/WhiteButton';
import {useTranslation} from 'react-i18next';
import {ButtonProps} from '@chakra-ui/react';

interface VoirPdfButtonProps extends Omit<ButtonProps, 'texte' | 'onClick'> {
  storagePath: string | undefined;
}

export const VoirPdfButton: React.FC<VoirPdfButtonProps> = ({
  storagePath,
  isDisabled,
  ...props
}) => {
  const {t} = useTranslation();

  const handleVoirPdf = () => {
    if (storagePath) {
      const bucketUrl = 'https://storage.googleapis.com/ffconnect-medias/';
      const pdfUrl = `${bucketUrl}${storagePath}`;
      window.open(pdfUrl, '_blank');
    }
  };

  // Sans chemin, il n'y a pas de fichier à ouvrir et le bouton n'a pas lieu
  // d'être — sauf si l'appelant demande explicitement un bouton désactivé,
  // pour réserver la place le temps que le chemin lui parvienne.
  if (!storagePath && !isDisabled) {
    return null;
  }

  return (
    <WhiteButton
      px={6}
      w='140px'
      texte={t('back_office.pdf_order_import.voir_fichier_pdf')}
      onClick={handleVoirPdf}
      isDisabled={isDisabled}
      {...props}
    />
  );
};
